module.exports = __webpack_public_path__ + "static/media/viug.c0a79088.png";